export class ConsecutivereportModel {


}
